import React from 'react'

import Terms, { TermsProps } from 'components/Terms'

const TermsWills = ({ pageContext }: TermsProps) => (
  <Terms pageContext={pageContext} />
)

export default TermsWills
